var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.00065C14.6663 11.6826 11.6816 14.6673 7.99967 14.6673M14.6663 8.00065C14.6663 4.31875 11.6816 1.33398 7.99967 1.33398M14.6663 8.00065H1.33301M7.99967 14.6673C4.31778 14.6673 1.33301 11.6826 1.33301 8.00065M7.99967 14.6673C9.66719 12.8417 10.6148 10.4726 10.6663 8.00065C10.6148 5.52867 9.66719 3.15955 7.99967 1.33398M7.99967 14.6673C6.33215 12.8417 5.38451 10.4726 5.33301 8.00065C5.38451 5.52867 6.33215 3.15955 7.99967 1.33398M1.33301 8.00065C1.33301 4.31875 4.31778 1.33398 7.99967 1.33398",
    stroke: "#1A202C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.5623537a538e726e3a7aa2daf77ba5b2.svg";
export { ForwardRef as ReactComponent };